var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pe-course-site"},[_c('PlatDataGridSite',{attrs:{"grid-id":"PeCourseSite","show-label":"","show-title":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }